import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Custom fontSize keys from tailwind.config.ts must be registered so
// twMerge treats them as font-size (not text-color) and doesn't drop
// color utilities like text-primary-foreground when they appear together.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "label-1",
            "label-2",
            "label-3",
            "label-4",
            "body-1",
            "body-2",
            "body-3",
            "heading-1",
            "heading-2",
            "heading-3",
            "heading-4",
            "subtitle",
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
